<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <!--Laboratory form  -->
  <div
    *ngIf="!modal.context.isEdit"
    class="ui form"
    [formGroup]="groupForm"
    [ngClass]="{ loading: pending }"
  >
    <div class="field" [ngClass]="displayFieldCss('name')">
      <label> Group Name</label>
      <input formControlName="name" placeholder="Enter group name " />
      <app-field-error-display
        [displayError]="isFieldValid('name')"
        errorMsg="Please enter group name"
      >
      </app-field-error-display>
    </div>
  </div>
  <div class="ui form" appMargin marginT="5">
    <div class="field">
      <label>Select Group Users</label>
      <div class="ui small icon fluid input" style="margin: 5px">
        <input
          type="text"
          placeholder="Search user..."
          [formControl]="search"
        />
        <i class="search icon"></i>
      </div>
    </div>
  </div>
  <div
    class="scroll-wrapper ui basic segment"
    [ngClass]="{ loading: upending }"
    appPadding
    paddingL="0"
  >
    <div *ngIf="success || error" appsyMargin marginY="10px">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <div
      class="detail-panel link"
      *ngFor="let user of users"
      appMargin
      marginB="10"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutGap="15px"
      >
        <div fxFlex="10%">
          <img class="ui circular tiny image" src="assets/avatar/1.jpg" />
        </div>
        <div fxFlex="grow">
          <h4 class="sub-header" appMargin marginB="1">
            {{ user?.firstName }} {{ user?.lastName }}
          </h4>
          <div class="sub-item">
            <label class="ui circular teal label">{{ user?.active }}</label>
          </div>
        </div>
        <div fxFlex="auto">
          <!-- <sui-checkbox ></sui-checkbox>
                         -->
          <sui-checkbox (click)="selectUser(user)" [ngModel]="user.selected">
          </sui-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="submit()"
    autofocus
  >
    Continue
  </button>
</div>
